<div class="page-container">
	<nz-result nzStatus="404" nzTitle="404" nzSubTitle="{{ 'error.not-found' | translate }}">
		<div nz-result-extra>
			<button nz-button nzType="primary" (click)="navigateBack()">
				{{ 'error.back-to-previous-page' | translate }}
			</button>
		</div>
	</nz-result>
</div>
